import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_admin_orders = createAsyncThunk(
  'orders/get_admin_orders',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/admin/orders?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_poster_orders = createAsyncThunk(
  'orders/get_poster_orders',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/poster/orders?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_stock_orders = createAsyncThunk(
  'orders/get_stock_orders',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/stock/orders?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const stock_order_status_update = createAsyncThunk(
  'orders/stock_order_status_update',
  async ({ orderId, status, order_status }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put(
        `/stock/order-status/update/${orderId}`,
        { status, order_status },
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const stock_driver_status_update = createAsyncThunk(
  'orders/stock_driver_status_update',
  async ({ orderId, status }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put(
        '/stock/order-status/update',
        { orderId, status }, // Directly pass orderId and status
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_admin_controll_orders = createAsyncThunk(
  'orders/get_admin_controll_orders',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/controll/orders?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_admin_orders_status = createAsyncThunk(
  'orders/get_admin_orders_status',
  async ({ customerId, status }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/admin/orders-status/${status}`)
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_admin_order = createAsyncThunk(
  'orders/get_admin_order',
  async (orderId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/admin/order/${orderId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const admin_delete_order = createAsyncThunk(
  'orders/admin_delete_order',
  async ({ orderId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(`/admin-delete-order/${orderId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      console.error('Delete order error:', error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const admin_order_status_update = createAsyncThunk(
  'orders/admin_order_status_update',
  async (
    { orderId, status, paidStatus, reason, driverStatus, order_status },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.put(
        `/admin/order-status/update/${orderId}`,
        { status, paidStatus, reason, driverStatus, order_status },
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const admin_payment_status_update = createAsyncThunk(
  'orders/admin_payment_status_update',
  async ({ orderId, paidStatus }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.put(
        `/admin/payment-status/update/${orderId}`,
        { paidStatus },
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const poster_order_status_update = createAsyncThunk(
  'orders/poster_order_status_update',
  async (
    { orderId, paidStatus, status, reason },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.put(
        '/poster/order-status/update',
        { orderId, paidStatus, status, reason },
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const admin_controll_order_send = createAsyncThunk(
  'orders/admin_controll_order_send',
  async (
    { orderId, status, location, delivery, reason },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.put(
        '/control-send-status/order',
        { orderId, status, location, delivery, reason },
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_seller_orders = createAsyncThunk(
  'orders/get_seller_orders',
  async (
    { parPage, page, searchValue, sellerId },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/seller/orders/${sellerId}?page=${page}&searchValue=${searchValue}&parPage=${parPage}`,
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_seller_order = createAsyncThunk(
  'orders/get_seller_order',
  async (orderId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/seller/order/${orderId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

// export const seller_order_status_update = createAsyncThunk(
//   'orders/seller_order_status_update',
//   async ({ orderId, info }, { rejectWithValue, fulfillWithValue }) => {
//     try {
//       const { data } = await api.put(
//         `/seller/order-status/update/${orderId}`,
//         info,
//         { withCredentials: true }
//       )
//       return fulfillWithValue(data)
//     } catch (error) {
//       return rejectWithValue(error.response.data)
//     }
//   }
// )
// // End Method

//Notifications
export const get_seller_notifications = createAsyncThunk(
  'orders/get_seller_notifications',
  async (sellerId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/seller/notifications/${sellerId}`, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method
export const seller_notifications_delete = createAsyncThunk(
  'orders/seller_notifications_delete',
  async ({ sellerId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(
        `/seller/notifications/delete/${sellerId}`,
        { withCredentials: true }
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const seller_notification_status_update = createAsyncThunk(
  'orders/seller_notification_status_update',
  // async ({ orderId, info }, { rejectWithValue, fulfillWithValue }) => {
  async ({ notificationId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      console.log('data-1', notificationId)
      const { data } = await api.put(
        // /seller/order-status/update/${orderId},
        `/seller/notification-status/update/${notificationId}`,
        { withCredentials: true }
      )
      console.log('data-44', data)
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const OrderReducer = createSlice({
  name: 'order',
  initialState: {
    successMessage: '',
    successNotification: '',
    errorMessage: '',
    totalOrder: 0,
    authNotifications: {},
    myNotifications: [],
    totalNotification: 0,
    order: {},
    orders: [],
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
      state.successNotification = ''
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(get_poster_orders.fulfilled, (state, { payload }) => {
        state.orders = payload.orders
        state.totalOrder = payload.totalOrder
      })

      .addCase(get_admin_controll_orders.fulfilled, (state, { payload }) => {
        state.orders = payload.orders
        state.totalOrder = payload.totalOrder
      })
      .addCase(get_stock_orders.fulfilled, (state, { payload }) => {
        state.orders = payload.orders
        state.totalOrder = payload.totalOrder
      })

      .addCase(get_admin_orders.fulfilled, (state, { payload }) => {
        state.orders = payload.orders
        state.totalOrder = payload.totalOrder
      })

      .addCase(get_admin_orders_status.fulfilled, (state, { payload }) => {
        state.orders = payload.orders
        state.totalOrder = payload.totalOrder
      })
      .addCase(get_admin_order.fulfilled, (state, { payload }) => {
        state.order = payload.order
      })
      .addCase(admin_order_status_update.rejected, (state, { payload }) => {
        state.errorMessage = payload.message
      })
      .addCase(admin_order_status_update.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message
      })

      .addCase(stock_order_status_update.rejected, (state, { payload }) => {
        state.errorMessage = payload.message
      })
      .addCase(stock_order_status_update.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message
      })

      .addCase(admin_payment_status_update.rejected, (state, { payload }) => {
        state.errorMessage = payload.message
      })
      .addCase(admin_payment_status_update.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message
      })

      .addCase(admin_delete_order.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.orders = payload.orders
      })

      .addCase(poster_order_status_update.rejected, (state, { payload }) => {
        state.errorMessage = payload.message
      })
      .addCase(poster_order_status_update.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message
        state.order = payload.order
        state.authNotifications = payload.notifications
      })
      .addCase(stock_driver_status_update.rejected, (state, { payload }) => {
        state.errorMessage = payload.message
      })
      .addCase(stock_driver_status_update.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message
        state.order = payload.order
      })

      .addCase(admin_controll_order_send.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message
        state.order = payload.order
      })

      .addCase(get_seller_orders.fulfilled, (state, { payload }) => {
        state.orders = payload.orders
        state.totalOrder = payload.totalOrder
      })
      .addCase(get_seller_order.fulfilled, (state, { payload }) => {
        state.order = payload.order
      })

      //Notifications

      .addCase(get_seller_notifications.fulfilled, (state, { payload }) => {
        state.myNotifications = payload.notifications
        state.totalNotification = payload.totalNotification
      })
      .addCase(
        seller_notification_status_update.rejected,
        (state, { payload }) => {
          state.errorMessage = payload.message
        }
      )
      .addCase(
        seller_notification_status_update.fulfilled,
        (state, { payload }) => {
          // state.successMessage = payload.message;
          state.successNotification = payload.message
        }
      )
  },
})
export const { messageClear } = OrderReducer.actions
export default OrderReducer.reducer
